import React, { useState } from "react";
import { motion } from "framer-motion";
import { Instagram, Twitter, Youtube, Facebook, Send } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/waitlist", { email, source: "footer" });
      toast.success(data.message);
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const socials = [
    { Icon: Instagram, label: "instagram" },
    { Icon: Twitter, label: "twitter" },
    { Icon: Youtube, label: "youtube" },
    { Icon: Facebook, label: "facebook" },
  ];

  return (
    <footer className="relative bg-black border-t border-white/10 overflow-hidden" data-testid="footer">
      <div className="halftone absolute inset-0 opacity-40" />
      <div className="relative max-w-[1500px] mx-auto px-5 sm:px-8 pt-16 pb-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <h3 className="font-display text-5xl sm:text-6xl leading-none">
              <span className="text-emerald-400 text-glow-green">NAIJA</span>
              <span className="text-amber-500">MAN</span>
            </h3>
            <p className="text-gray-400 mt-4 max-w-md">
              The green surge that defends the streets and carries the pride of a nation. New issues, exclusive art, and behind-the-scenes — straight to your inbox.
            </p>
            <div className="flex gap-3 mt-6">
              {socials.map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="w-11 h-11 grid place-items-center rounded-full border border-white/15 text-gray-300 hover:text-emerald-950 hover:bg-emerald-400 hover:border-emerald-400 transition-colors duration-200"
                  data-testid={`footer-social-${label}`}
                  aria-label={label}
                >
                  <Icon size={19} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:justify-self-end w-full max-w-md">
            <p className="font-accent text-2xl tracking-wider text-white">JOIN THE NAIJAMAN UNIVERSE</p>
            <p className="text-gray-400 text-sm mt-1">Get free previews and updates.</p>
            <form onSubmit={submit} className="mt-4 flex gap-2" data-testid="footer-newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="flex-1 bg-white/5 border border-white/15 rounded-md px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-400"
                data-testid="footer-newsletter-input"
              />
              <motion.button
                whileTap={{ scale: 0.95 }}
                disabled={loading}
                className="btn-skew bg-amber-500 hover:bg-amber-400 text-black font-accent text-lg tracking-wide px-5 flex items-center gap-2 disabled:opacity-60"
                data-testid="footer-newsletter-submit"
              >
                <span className="flex items-center gap-2"><Send size={16} /> Go</span>
              </motion.button>
            </form>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-gray-500">
          <p data-testid="footer-copyright">© 2025 www.naijamancomics.com · Changa Studios. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-gray-300">Privacy</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-gray-300">Terms</a>
            <a href="mailto:hello@naijamancomics.com" className="hover:text-gray-300">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
